"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTreasuryTotalHolding = getTreasuryTotalHolding;
async function getTreasuryTotalHolding() {
    const treasury_url = "https://api.alphafi.xyz/stats/treasury";
    const treasuryResponse = await fetch(treasury_url);
    if (!treasuryResponse.ok) {
        const errorText = await treasuryResponse.text();
        throw new Error(`HTTP error! status: ${treasuryResponse.status}, response: ${errorText}`);
    }
    const treasuryHoldings = (await treasuryResponse.json());
    let response = "";
    const totalHoldings = treasuryHoldings["TOTAL"];
    if (!totalHoldings)
        throw new Error("Total Holding not found in stats/treasury API response");
    if ("totalUsdBalance" in totalHoldings)
        response = totalHoldings.totalUsdBalance;
    else
        throw new Error("Incorrect Total Holding type");
    return response;
}
//# sourceMappingURL=treasury.js.map